import { render, staticRenderFns } from "./AuroReleaseCard.vue?vue&type=template&id=43efc58e"
import script from "./AuroReleaseCard.vue?vue&type=script&lang=js"
export * from "./AuroReleaseCard.vue?vue&type=script&lang=js"
import style0 from "./AuroReleaseCard.vue?vue&type=style&index=0&id=43efc58e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports